import { types as t, flow } from 'mobx-state-tree';

import { UserRef } from 'models/users';
import { withEnv } from 'models/withEnv';

export const JobAttachment = t
  .model('JobAttachment', {
    attachment: t.maybeNull(t.string),
    attachmentOriginal: t.maybeNull(t.string),
    blob: t.optional(t.frozen(), null),
    id: t.identifierNumber,
    loaded: false,
    fileName: t.maybe(t.string),
    date: t.maybeNull(t.optional(t.string, '')),
    user: t.maybeNull(
      t.union(
        t.undefined,
        t.late(() => UserRef),
      ),
    ),
  })
  .views(withEnv)
  .views((self) => ({
    get noPreview() {
      return self.attachment && self.loaded && self.blob === null;
    },
    get name() {
      return self.fileName;
    },
  }))
  .actions((self) => ({
    loadAttachment: flow(function* () {
      if (self.loaded) return;
      if (!self.attachment) {
        self.loaded = true;
        return;
      }

      const res = yield self.env.api.applications.loadBlob(self.attachment);
      if (res.status === 200) {
        self.blob = res.data;
      }
      self.loaded = true;
    }),
  }));
